module.exports = __webpack_public_path__ + "img/public/SiteIcons/stepCompletedIcon.svg?48b05f37";